import React, { useState, useCallback, useEffect, useMemo } from "react";
import {
  View,
  Text,
  Modal,
  Button,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import {
  Paper,
  InputBase,
  IconButton,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { styles } from "../../style/FoundryStyle.js";
import { backgroundColor2 } from "../../constants/Constants.js";
import { getDatosExcel } from "../../services/ConnectDataBase.js";
import { typeConnect, SCREEN_IDS } from "../../constants/Constants.js";
import { BACKGROUND_COLORS, SHADOW_COLORS, TEXT_COLORS, LOADING_COLORS } from "../../style/colors.js";
import { translateText } from "../../translations/translationService";
import { useSelector } from "react-redux";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  rows: 8,              // Número de filas de skeletons
  height: 20,           // Altura de los skeletons en px
  widthLabel: "100%",    // Ancho del skeleton de etiqueta
  widthValue: "100%",    // Ancho del skeleton de valor
};

const InformacionEnDetalleDos = () => {
  const lang = useSelector((state) => state.lang.value);
  const [searchTerm, setSearchTerm] = useState("");
  const [fechaInicio, setFechaInicio] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [fechaFin, setFechaFin] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [referenciasUnicas, setReferenciasUnicas] = useState([]);
  const [refExpandida, setRefExpandida] = useState(null);
  const [datosOrdenadosPorFecha, setDatosOrdenadosPorFecha] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const consultaExcel = async () => {
      setIsLoading(true);
      try {
        const fullPOAndMO = await getDatosExcel(
          "TIEMPOS",
          typeConnect[0],
          SCREEN_IDS.GENERAL
        );

        const datosRaw = fullPOAndMO?.data || [];

        const datosOrdenados = [...datosRaw].sort((a, b) => {
          const fechaA = new Date(
            a.fecha_proceso.split("-").reverse().join("-")
          );
          const fechaB = new Date(
            b.fecha_proceso.split("-").reverse().join("-")
          );
          return fechaB - fechaA; // De más reciente a más antiguo
        });

        setDatosOrdenadosPorFecha(datosOrdenados);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    consultaExcel();
  }, []);

  const referenciasFiltradas = useMemo(() => {
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);
    fin.setHours(23, 59, 59, 999); // Asegura incluir todo el día

    const datosEnRango = datosOrdenadosPorFecha.filter((item) => {
      const fechaItem = new Date(
        item.fecha_proceso.split("-").reverse().join("-")
      );
      return fechaItem >= inicio && fechaItem <= fin;
    });

    const referencias = Array.from(
      new Set(datosEnRango.map((item) => item.referencia))
    );

    setReferenciasUnicas(referencias);
    return datosEnRango;
  }, [datosOrdenadosPorFecha, fechaInicio, fechaFin]);

  const renderRows = () => {
    return referenciasUnicas.map((ref, index) => {
      const datosReferencia = referenciasFiltradas.filter(
        (d) => d.referencia === ref
      );
      const isExpanded = refExpandida === ref;

      return (
        <React.Fragment key={ref}>
          <TableRow
            onClick={() =>
              setRefExpandida((prev) => (prev === ref ? null : ref))
            }
                            style={{ backgroundColor: BACKGROUND_COLORS.CARD, cursor: "pointer" }}>
            <TableCell
              colSpan={6}
              style={{ textAlign: "center", fontWeight: "bold" }}>
              {ref}
            </TableCell>
          </TableRow>

          {isExpanded &&
            datosReferencia.map((item, subIndex) => {
              const cantidad = parseFloat(item.cantidad);
              const tiempoTeorico = parseFloat(item.tiempo_teorico);
              const duracion = parseFloat(item.duracion);

              const minReal = (duracion / cantidad).toFixed(2);
              const minStand = (tiempoTeorico / cantidad).toFixed(2);
              const minExtra = (minReal - minStand).toFixed(2);
              const eficiencia =
                isFinite(minExtra) && isFinite(minStand)
                  ? ((minExtra / minStand) * 100).toFixed(2) + " %"
                  : "N/A";

              return (
                <TableRow key={`${ref}-${subIndex}`}>
                  <TableCell style={{ textAlign: "center" }}>
                    {item.descripcion}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {cantidad.toFixed(2)}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {minReal}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {minStand}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {minExtra}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {eficiencia}
                  </TableCell>
                </TableRow>
              );
            })}
        </React.Fragment>
      );
    });
  };

  return (
    <View style={styles.containerRepairScreen}>
      <View style={styles.tableRepairScreen}>
        {/* Controles superiores */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
            padding: 10,
                            backgroundColor: BACKGROUND_COLORS.TABLE_HEADER,
            borderRadius: 10,
            marginTop: -15,
                            shadowColor: SHADOW_COLORS.PRIMARY,
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.2,
            shadowRadius: 2,
            elevation: 3,
          }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {/* Búsqueda */}
            <Paper
              component='form'
              sx={{
                display: "flex",
                alignItems: "center",
                width: 200,
                height: 40,
                mr: 2,
                backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
              }}
              onSubmit={(e) => e.preventDefault()}>
              <InputBase
                sx={{ ml: 1, flex: 1, height: "100%" }}
                placeholder={translateText("Buscar ref.", lang)}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <IconButton type='submit' sx={{ p: "10px" }}>
                <SearchIcon />
              </IconButton>
            </Paper>

            {/* Selector de fecha */}
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                width: 200,
                height: 40,
                backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
              }}>
              <InputBase
                type='date'
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                sx={{
                  flex: 1,
                  height: "100%",
                  padding: "8px",
                }}
              />
            </Paper>

            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                width: 200,
                height: 40,
                ml: 2,
                backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
              }}>
              <InputBase
                type='date'
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
                sx={{
                  flex: 1,
                  height: "100%",
                  padding: "8px",
                }}
              />
            </Paper>
          </View>

          <TouchableOpacity
            style={{
              backgroundColor: backgroundColor2,
              paddingVertical: 10,
              paddingHorizontal: 20,
              borderRadius: 5,
              alignItems: "flexEnd",
              justifyContent: "center",
              marginLeft: 20,
              cursor: "pointer",
            }}
            onPress={() => console.log("Botón funcionalidad futura")}>
            <Text
              style={{
                color: TEXT_COLORS.LIGHT,
                fontWeight: "bold",
                fontSize: 16,
                marginHorizontal: 10,
              }}>
              Acción
            </Text>
          </TouchableOpacity>
        </View>

        {/* Tabla o loading */}
        {isLoading ? (
          <TableContainer component={Paper} style={{ maxHeight: "69vh" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow style={{ backgroundColor: BACKGROUND_COLORS.SECONDARY }}>
                  {[
                    "Referencia",
                    "Cantidad",
                    "Min Real",
                    "Min Stand",
                    "Min Extra",
                    "Ineficiencia (%)",
                  ].map((header, i) => (
                    <TableCell
                      key={i}
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        backgroundColor: BACKGROUND_COLORS.SECONDARY,
                      }}>
                      <Skeleton variant="text" width="80%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.3)", mx: "auto" }} />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {[...Array(SKELETON_CONFIG.rows)].map((_, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    style={{
                      backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : BACKGROUND_COLORS.CARD || "#f5f5f5",
                    }}>
                    {[...Array(6)].map((_, colIndex) => (
                      <TableCell
                        key={colIndex}
                        style={{
                          textAlign: "center",
                          padding: "4px 8px",
                        }}>
                        <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableContainer component={Paper} style={{ maxHeight: "69vh" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow style={{ backgroundColor: BACKGROUND_COLORS.SECONDARY }}>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Referencia
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Cantidad
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Min Real
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Min Stand
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Min Extra
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      backgroundColor: BACKGROUND_COLORS.SECONDARY, // Aplica aquí directamente
                    }}>
                    Ineficiencia (%)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderRows()}</TableBody>
            </Table>
          </TableContainer>
        )}
      </View>

      {/* Modal futuro si lo necesitas */}
      <Modal
        visible={isModalVisible}
        transparent={true}
        animationType='fade'
        onRequestClose={() => setIsModalVisible(false)}>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}>
          <View
            style={{
              backgroundColor: "white",
              padding: 20,
              borderRadius: 10,
              width: "90%",
              maxHeight: "90%",
            }}>
            <Text
              style={{ fontSize: 18, fontWeight: "bold", marginBottom: 10 }}>
              Modal Personalizado
            </Text>
            {/* Aquí irá tu contenido */}
            <Button title='Cerrar' onPress={() => setIsModalVisible(false)} />
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default InformacionEnDetalleDos;
